module.exports = __webpack_public_path__ + "static/media/CircularPro-Book.9b3969dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Book.svg
// module id = 107
// module chunks = 0